import { render, staticRenderFns } from "./ListeningSoundForm.vue?vue&type=template&id=5be0bcd8&"
import script from "./ListeningSoundForm.vue?vue&type=script&lang=js&"
export * from "./ListeningSoundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports